<template>
	<div class="card-layout">
		<!-- 平均排名卡片 -->
		<div class="avg-card" v-if="type == 'avg'">
			<div class="img-top">
				<img src="@/assets/google-img.png" alt="" />
			</div>
			<div class="card-bottom">
				<!-- 平均排名 -->
				<div class="bottom-left">
					<div class="number">
						<span class="big-number">{{
							Math.round(argRankAndkeyWordInfo.rankingAvg) || '-'
						}}</span>
						<ig-icon
							v-if="argRankAndkeyWordInfo.rankingAvgComparison < 0"
							name="xiajiang"
							class="xiajiang"
						></ig-icon>
						<ig-icon v-else name="shangsheng" class="shangsheng"></ig-icon>
						<span>{{
							(argRankAndkeyWordInfo.rankingAvgComparison > 0
								? '+' + Math.round(argRankAndkeyWordInfo.rankingAvgComparison)
								: Math.round(argRankAndkeyWordInfo.rankingAvgComparison)) || '-'
						}}</span>
					</div>
					<el-button type="primary" plain class="rank-btn">平均排名</el-button>
				</div>
				<!-- 有排名关键词 -->
				<div class="bottom-right">
					<div class="number">
						<span class="big-number">{{
							Math.round(argRankAndkeyWordInfo.rankingCount) || '-'
						}}</span>
						<ig-icon
							v-if="argRankAndkeyWordInfo.rankingCountComparison < 0"
							name="xiajiang"
							class="xiajiang"
						></ig-icon>
						<ig-icon v-else name="shangsheng" class="shangsheng"></ig-icon>
						<span>{{
							(argRankAndkeyWordInfo.rankingCountComparison >= 0
								? '+' + Math.round(argRankAndkeyWordInfo.rankingCountComparison)
								: Math.round(argRankAndkeyWordInfo.rankingCountComparison)) || '-'
						}}</span>
					</div>
					<el-button type="primary" plain class="rank-btn">有排名关键词</el-button>
				</div>
			</div>
		</div>
		<!-- 关键词排名卡片 -->
		<div class="keyword-card" v-if="type == 'keyword'">
			<div
				class="card-item"
				v-for="(item, index) in argRankAndkeyWordInfo.keywordList"
				:key="index"
				:style="'width:' + 100 / argRankAndkeyWordInfo.keywordList.length + '%;'"
			>
				<div class="number">
					<span class="big-number" @click="toDetails('rank', item.rank)">{{
						item.rankingCount || 0
					}}</span>
					<ig-icon
						v-if="argRankAndkeyWordInfo.rankingTop5CountComparison < 0"
						name="xiajiang"
						class="xiajiang"
					></ig-icon>
					<ig-icon v-else name="shangsheng" class="shangsheng"></ig-icon>
					<span>{{
						item.rankingCountComparison >= 0
							? '+' + item.rankingCountComparison || 0
							: item.rankingCountComparison || 0
					}}</span>
				</div>
				<el-button type="primary" plain class="rank-btn">{{ item.name }}</el-button>
			</div>
			<div class="no-keyword" v-if="argRankAndkeyWordInfo.keywordList.length == 0">
				<img src="@/assets/no-keyword.png" alt="" />
				<div>
					您的网站关键词还在努力进入到
					Google排名中，继续保持网站更新频率以及在更多的行业网站上发布网站相关信息以此来提升关键词的排名。
				</div>
			</div>
		</div>
		<div v-if="type == 'country'" class="country-card">
			<div
				class="country-item"
				v-for="(item, index) in countryList"
				:key="index"
				:class="index == 1 ? 'first' : index == 0 ? 'second' : 'third'"
			>
				<img src="@/assets/second.png" v-if="index === 0" alt="" />
				<img src="@/assets/first.png" v-if="index === 1" alt="" />
				<img src="@/assets/third.png" v-if="index === 2" alt="" />
				<div class="country-name">{{ item.geoLocation }}</div>
				<div class="keyword-number">
					关键词数量<span @click="toDetails('country', item)">{{ item.rankingCount }}</span>
				</div>
			</div>
			<div class="data-empty" v-if="countryList.length === 0">
				<img class="img" src="https://img.iglobalwin.com/nodata.png" />
				<div class="hint">暂无数据</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'rank-card',
	props: {
		countryList: {
			type: Array,
		},
		argRankAndkeyWordInfo: {
			type: Object,
		},
		type: {
			type: String,
		},
	},
	data() {
		return {
			countryInfo: [
				{
					label: '澳大利亚',
					value: 'AU',
				},
				{
					label: '加拿大',
					value: 'CA',
				},
				{
					label: '德国',
					value: 'DE',
				},
				{
					label: '西班牙',
					value: 'ES',
				},
				{
					label: '法国',
					value: 'FR',
				},
				{
					label: '日本',
					value: 'JP',
				},
				{
					label: '墨西哥',
					value: 'MX',
				},
				{
					label: '美国',
					value: 'US',
				},
				{
					label: '英国',
					value: 'UK',
				},
				{
					label: '印度',
					value: 'IN',
				},
			],
		};
	},
	methods: {
		toDetails(type, val) {
			switch (type) {
				case 'rank':
					this.$router.push({
						path: 'keywordRanking',
						query: { tabs: 'detailedData', ranking: val },
					});
					break;
				case 'country':
					let { value } = this.countryInfo.filter(item => {
						return item.label === val.geoLocation;
					})[0];
					this.$router.push({
						path: 'keywordRanking',
						query: { tabs: 'detailedData', geoLocation: value },
					});
					break;
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.card-layout {
	height: 100%;
}

.avg-card {
	height: 100%;

	.img-top {
		display: flex;
		justify-content: center;
		margin-top: 30px;
		img {
			width: 85px;
		}
	}

	.card-bottom {
		margin-top: 50px;
		display: flex;
		justify-content: space-between;
	}

	.bottom-left,
	.bottom-right {
		width: 50%;
		text-align: center;
	}

	.bottom-left {
		border-right: 1px solid #e8e8e8;
	}
}

.rank-btn {
	font-size: 14px;
	padding: 5px 20px;
	color: #3da1ff;
	border: none;
	border-radius: 20px;
	line-height: 20px;
	margin-top: 20px;
}

.number {
	font-size: 14px;
	font-weight: 500;
	color: #333333;
}

.big-number {
	font-size: 36px;
	color: #333333;
	font-weight: 600;
}

.shangsheng,
.xiajiang {
	font-size: 12px;
	margin: 0 5px;
}

.xiajiang {
	color: #52c41a;
}

.shangsheng {
	color: #f5222d;
}
.keyword-card {
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	justify-content: space-between;
	box-sizing: border-box;
	height: 100%;

	.card-item {
		text-align: center;
		width: 25%;
		border-left: 1px solid #e8e8e8;
		&:first-child {
			border-left: none;
		}
		.big-number {
			color: #3da1ff;
			cursor: pointer;
		}
	}
}

.country-card {
	display: flex;
	justify-content: center;
	align-items: flex-end;
	height: 100%;
	box-sizing: border-box;
	padding-top: 20px;
	height: 180px;

	.country-item {
		width: 26%;
		height: 132px;
		background: linear-gradient(180deg, #efefef 0%, #ffffff 100%);
		border-radius: 8px 8px 0px 0px;
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: relative;
		img {
			width: 60px;
			position: absolute;
			top: -34px;
		}

		.country-name {
			font-size: 16px;
			font-weight: 600;
			color: #333333;
			line-height: 22px;
			margin-top: 36px;
		}

		.keyword-number {
			font-size: 12px;
			font-weight: 400;
			color: #999999;
			line-height: 17px;
			margin-top: 20px;

			span {
				font-size: 24px;
				font-weight: 600;
				color: #3da1ff;
				margin-left: 20px;
				cursor: pointer;
			}
		}
	}

	.first {
		height: 152px;
		background: linear-gradient(179deg, #fffbee 0%, #ffffff 100%);
		margin-left: 30px;
		.country-name {
			margin-top: 0;
		}
	}

	.third {
		height: 112px;
		background: linear-gradient(180deg, #fff3ee 0%, #ffffff 100%);
		margin-left: 30px;
		.country-name {
			margin-top: 40px;
		}
	}
}
.el-button--primary {
	cursor: default;
}
.el-button--primary.is-plain:focus,
.el-button--primary.is-plain:hover {
	background-color: #ecf5ff;
	border-color: #ecf5ff;
	color: #409eff;
}
.no-keyword {
	padding: 0 40px;
	padding-bottom: 20px;
	text-align: center;
	img {
		width: 134px;
	}
	> div {
		text-align: left;
		font-size: 14px;
		color: #666666;
		margin-top: 10px;
	}
}
.data-empty {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100%;
	.img {
		width: 150px;
		margin-top: -100px;
	}
	.hint {
		margin-top: 10px;
		font-size: 15px;
		color: #666666;
	}
}
</style>
